import { render, staticRenderFns } from "./mobile-menu.component.vue?vue&type=template&id=36c061a5"
import script from "./mobile-menu.component.vue?vue&type=script&lang=js"
export * from "./mobile-menu.component.vue?vue&type=script&lang=js"
import style0 from "./mobile-menu.component.vue?vue&type=style&index=0&id=36c061a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports